import React, { useMemo } from "react";
import { Details } from "components/src/components/Details/Details";
import { Icon } from "components/src/components/Icon/Icon";
import cx from "components/src/utils/cx";
import {
  SemanticColorType,
  tailwindSemanticBgColors,
} from "shared/src/styles/colorStyles";
import { SizeType } from "shared/src/types";
import { DetailProps } from "components/src/components/Details/types";
import { IconProps } from "components/src/components/Icon/types";
import { TempChevron } from "../../../templates/components/AlternateHeader";

export const MarketFixtureHeader = ({
  title,
  id,
  description,
  leadingIcon,
  trailingDetails = [],
  collapsible,
  headerBg = "bg-primary-minimal",
  actionText,
  hideActionText,
  headerTextSize = "heading-lg-bold",
  isOpen,
  onClick,
}: {
  isOpen: boolean;
  id?: string;
  title?: string;
  leadingIcon?: IconProps | string;
  trailingDetails?: DetailProps[] | null;
  collapsible?: boolean;
  headerBg?: string;
  description?: string;
  hideActionText?: boolean;
  headerTextSize?: string;
  actionText?: string;
  onClick?: (args: {
    e?: React.MouseEvent<HTMLDivElement>;
    id?: string;
  }) => void | null;
}) => {
  let _LeadingIcon;
  if (typeof leadingIcon === "string")
    _LeadingIcon = <Icon name={leadingIcon} size="lg" />;
  if (typeof leadingIcon === "object") _LeadingIcon = <Icon {...leadingIcon} />;

  const rightList = useMemo(() => {
    const moreTag: DetailProps = {
      tag: actionText ? actionText : "More",
      rightIcon: {
        name: "ui_chevron_right",
        size: "md" as SizeType,
        color: "fg-primary",
      },
      fgColor: "fg-primary" as SemanticColorType,
    };

    if (trailingDetails && Array.isArray(trailingDetails))
      return [...trailingDetails, collapsible ? null : moreTag];
    return !collapsible && !hideActionText ? [moreTag] : [];
  }, [title, leadingIcon, collapsible, trailingDetails]);

  const handleOnClick = (e) => {
    onClick && onClick(e);
  };

  return (
    <div
      className={cx(
        {
          [tailwindSemanticBgColors[headerBg]]: true,
          "cui-items-center": !!!description,
          "cui-items-start": !!description,
        },
        "cui-flex cui-justify-between cui-px-md cui-py-sm cui-cursor-pointer cui-min-h-[32px]"
      )}
      style={{ background: headerBg }}
      onClick={handleOnClick}
    >
      <div className="cui-flex-col">
        <div className="cui-flex cui-items-start cui-flex-shrink">
          {_LeadingIcon ? <div className="cui-h-2">{_LeadingIcon}</div> : null}
          <div
            className={cx(
              {
                "cui-ml-xs": !!_LeadingIcon,
                [headerTextSize]: !!headerTextSize
              },
              "cui-text-fg-default cui-self-center"
            )}
          >
            {title}
          </div>
        </div>
        {!!description ? (
          <span className="heading-xs-bold cui-text-fg-default">
            {description}
          </span>
        ) : null}
      </div>
      <TrailingDetails
        collapsible={collapsible}
        list={rightList}
        isOpen={isOpen}
      />
    </div>
  );
};

const TrailingDetails = ({ collapsible, isOpen, list }) => {
  return (
    <div className="cui-flex cui-items-center cui-justify-end cui-gap-xs cui-w-auto cui-ml-xs cui-min-w-[64px]">
      <Details list={list} />
      {collapsible ? (
        <TempChevron
          className={cx({
            "cui-rotate-180": !isOpen,
          })}
        />
      ) : null}
    </div>
  );
};
